import { render, staticRenderFns } from "./SongDetailPanel.vue?vue&type=template&id=f02ccc88&scoped=true&"
import script from "./SongDetailPanel.vue?vue&type=script&lang=js&"
export * from "./SongDetailPanel.vue?vue&type=script&lang=js&"
import style0 from "./SongDetailPanel.vue?vue&type=style&index=0&id=f02ccc88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02ccc88",
  null
  
)

export default component.exports